import {useAuthStore} from "@/stores/Auth";
import {CRM_RESOURCE, VALUE_RESOURCE} from "@/stores/resources";

// Returns true on failure (caller should bail out of the API call).
// Refreshes the value access token; redirects to login if no session is recoverable.
export async function ensureValueAccessOrLogin(): Promise<boolean> {
    const authStore = useAuthStore();
    await authStore.ensureValueAccessOrLogin();
    if (!authStore.getAccessToken(VALUE_RESOURCE)) {
        console.error('User not authenticated - login required');
        return true;
    }
    return false;
}

// Returns true on failure. CRM-only failure does NOT trigger a logout/redirect —
// callers should just abort the CRM call and surface the error.
export async function ensureCrmAccess(): Promise<boolean> {
    const authStore = useAuthStore();
    const ok = await authStore.ensureFreshAccessToken(CRM_RESOURCE);
    if (!ok) {
        console.error('Unable to acquire CRM access token');
        return true;
    }
    return false;
}
